import React, { useState } from 'react';
import { toast } from '@raytolfas/toastify';
import '@raytolfas/toastify/toastify.css';
import './App.css';

const App = () => {
  const [toastMessage, setToastMessage] = useState('Welcome to Raytolfas!');
  const [toastType, setToastType] = useState('success');
  const [toastDuration, setToastDuration] = useState(3000);
  const [toastPosition, setToastPosition] = useState('top-right');
  const [toastTheme, setToastTheme] = useState('light');

  const generatedCode = `import { toast } from '@raytolfas/toastify';
import '@raytolfas/toastify/toastify.css';

toast({
  message: '${toastMessage || 'Welcome to Raytolfas!'}',
  type: '${toastType}',
  duration: ${toastDuration || 3000},
  position: '${toastPosition}',
  theme: '${toastTheme}',
});`;

  const handleShowToast = () => {
    if (!toastMessage.trim()) {
      toast({
        message: 'Ошибка: Введите сообщение тоста!',
        type: 'error',
        duration: Number(toastDuration) || 3000,
        position: toastPosition,
        theme: toastTheme,
      });
      return;
    }
    toast({
      message: toastMessage || 'Welcome to Raytolfas!',
      type: toastType,
      duration: Number(toastDuration) || 3000,
      position: toastPosition,
      theme: toastTheme,
    });
  };

  const handleCopyCode = () => {
    navigator.clipboard.writeText(generatedCode);
    toast({
      message: 'Код скопирован в буфер обмена!',
      type: 'success',
      duration: Number(toastDuration) || 3000,
      position: toastPosition,
      theme: toastTheme,
    });
  };

  return (
    <div className="app">
      <header className="header">
        <h1 className="header-title">Raytolfas Toastify Test</h1>
        <a href="https://docs.raytolfas.com" className="docs-button" target="_blank" rel="noopener noreferrer">
          DOCS
        </a>
      </header>
      <main className="container">
        <div className="settings-card">
          <div className="setting">
            <label className="label">Сообщение тоста:</label>
            <input
              type="text"
              value={toastMessage}
              onChange={(e) => setToastMessage(e.target.value)}
              placeholder="Введите сообщение"
              className="input-field"
            />
          </div>
          <div className="setting">
            <label className="label">Тип тоста:</label>
            <select
              value={toastType}
              onChange={(e) => setToastType(e.target.value)}
              className="select-field"
            >
              <option value="success">Success</option>
              <option value="error">Error</option>
              <option value="info">Info</option>
              <option value="warning">Warning</option>
            </select>
          </div>
          <div className="setting">
            <label className="label">Длительность (мс):</label>
            <input
              type="number"
              value={toastDuration}
              onChange={(e) => setToastDuration(e.target.value)}
              placeholder="3000"
              className="input-field"
            />
          </div>
          <div className="setting">
            <label className="label">Позиция тоста:</label>
            <select
              value={toastPosition}
              onChange={(e) => setToastPosition(e.target.value)}
              className="select-field"
            >
              <option value="top-right">Верх-право</option>
              <option value="top-left">Верх-лево</option>
              <option value="bottom-right">Низ-право</option>
              <option value="bottom-left">Низ-лево</option>
            </select>
          </div>
          <div className="setting">
            <label className="label">Тема тоста:</label>
            <select
              value={toastTheme}
              onChange={(e) => setToastTheme(e.target.value)}
              className="select-field"
            >
              <option value="light">Светлая</option>
              <option value="dark">Тёмная</option>
            </select>
          </div>
          <button
            onClick={handleShowToast}
            className="action-button show-toast"
          >
            Показать тост
          </button>
        </div>
        <div className="code-card">
          <h2 className="code-title">Сгенерированный код</h2>
          <textarea
            className="code-output"
            value={generatedCode}
            readOnly
          />
          <button
            onClick={handleCopyCode}
            className="action-button copy-button"
          >
            Скопировать код
          </button>
        </div>
      </main>
    </div>
  );
};

export default App;